import React from "react";
import styled from "@emotion/styled";

export default function SendButton(props) {
  return (
    <StyledButton {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
      </svg>
    </StyledButton>
  );
}

const StyledButton = styled.button`
  background: #5b6bfd;
  color: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: #4857e9;
  }

  &:disabled {
    background: ${(props) => props.theme.gray.gray400};
    cursor: not-allowed;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;
